angular.module('refundPointList', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/refund-point-list/refund-point-list.module.js